import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'
import JsonApiObject from '@/_models/JsonApi'
import VBITLog from '@/components/Menu/dialogs/vbitLog/vbitLog.vue'

@Component({
    mixins: [UserMixin],
})
export default class LogoListItem extends Mixins<MixinInterface>(UserMixin) {
    @Prop({ default: 30 }) size!: number

    showNews() {
        JsonApiObject.openDialog(VBITLog, {})
        if (this.hasNews) {
            this.updateUserSettings()
        }
    }

    get hasNews() {
        return this.$store.getters.frontEndSettings.lastVBITLogSeen
            ? this.$store.getters.frontEndSettings.lastVBITLogSeen > this.latestNews
            : true
    }

    get latestNews(): string {
        let str = Object.keys(this.$i18n.messages[this.$i18n.locale].vbit_log_msg).pop()
        return str ? str : ''
    }

    async updateUserSettings() {
        let frontEndSettings = {
            ...(this.$store.getters.frontEndSettings && {
                ...this.$store.getters.frontEndSettings,
            }),
            lastVBITLogSeen: this.latestNews,
        }
        this.$store.commit('frontEndSettings', frontEndSettings)

        let params = {
            updatedAt: this.$store.getters.user?.attributes.updatedAt,
            data: {
                id: this.currentUser.id,
                type: 'user',
                attributes: {
                    frontEndSettings: JSON.stringify(this.$store.getters?.frontEndSettings),
                },
            },
        }

        await this.handlePatchUser(params)
    }

    async handlePatchUser(params: any) {
        await this.patchUser(params).catch(async (error: any) => {
            if (error.data.response.status === 412) {
                await this.getUser(this.$store.getters.user.id).catch(() => {
                    //
                })

                params.updatedAt = this.$store.getters.user?.attributes.updatedAt

                await this.handlePatchUser(params)
            }
        })
    }
}
